import { APIDecoratorWithBaseURI } from '../../Service/api'

export interface useValidationProps {
  fetcher: (x: useAdavanceInvocePorps) => Promise<any>
}
type useAdavanceInvocePorps = {
  id: string
  advanceId: string
}
export const useAdvanceInvoice = (): useValidationProps => {
  const fetcher = async ({ id, advanceId }: useAdavanceInvocePorps) => {
    const url: string = `/producer/analytics/AdvanceInvoice?eventId=${id}&advanceId=${advanceId}`

    return await APIDecoratorWithBaseURI().get(url)
  }

  return {
    fetcher,
  }
}
